<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
          v-model="listQuery.id"
          placeholder="ID"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-input
          v-model="listQuery.keyword"
          placeholder="地址/名称/符号"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-button
          class="filter-item"
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
      >搜索
      </el-button
      >
      <el-button
          class="filter-item"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
      >创建
      </el-button
      >
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        size="large"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.mint }}
        </template>
      </el-table-column>

      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="符号" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.symbol }}
        </template>
      </el-table-column>

      <el-table-column label="图片" min-width="40" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.image" style="height: 40px;border-radius: 4px;"/>
        </template>
      </el-table-column>

      <el-table-column label="阶段" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.stage == 2" type="success">上市中</el-tag>
          <el-tag v-else-if="scope.row.stage == 0" type="primary">即将开始</el-tag>
          <el-tag v-else-if="scope.row.stage == 1 && scope.row.investing_deadline >= new Date().getTime()"
                  type="primary">私募中
          </el-tag>
          <el-tag v-else-if="scope.row.stage == 1 && scope.row.investing_deadline < new Date().getTime()"
                  type="warning">清退中
          </el-tag>
          <el-tag v-else type="info">未知</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success">正常</el-tag>
          <el-tag v-else type="warning">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="价格" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.token_price }}SOL
        </template>
      </el-table-column>

      <el-table-column label="市值" min-width="60" align="center">
        <template slot-scope="scope">
          ${{ Number(scope.row.market_cap_usd).toFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column label="24h交易额" min-width="60" align="center">
        <template slot-scope="scope">
          ${{ Number(scope.row.usd_volume_24h).toFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column label="发行方" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.creator }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>

      <el-table-column
          label="操作"
          align="center"
          width="320"
          class-name="small-padding fixed-width"
          fixed="right"
      >
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)"
              style="width: 80px"
          >编辑
          </el-button
          >
          <el-button
              size="mini"
              type="info"
              @click="handleBind(scope.row)"
              style="width: 80px"
          >绑定短剧
          </el-button
          >
          <el-button
              size="mini"
              type="warning"
              :loading="syncingMint === scope.row.mint"
              @click="handleSyncWhitelist(scope.row)"
              style="width: 100px"
          >同步白名单
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog v-if="dialogFormVisible" title="编辑" :visible.sync="dialogFormVisible" width="60%"
               :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini" label-width="120px" style="width: 90%;">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="form.name" clearable/>
        </el-form-item>
        <el-form-item label="符号" prop="name">
          <el-input type="text" v-model="form.symbol" clearable/>
        </el-form-item>
        <el-form-item label="图片" prop="name">
          <upload-aws
              prefix='token/image/'
              v-model="form.image"
          />
        </el-form-item>
        <el-form-item label="标签" prop="selectedTags">
          <el-select v-model="selectedTags" multiple placeholder="请选择" style="width: 100%;">
            <el-option
                v-for="item in tags"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" rows="2"/>
        </el-form-item>
        <el-form-item label="官网链接" prop="website">
          <el-input type="text" v-model="form.website" clearable/>
        </el-form-item>
        <el-form-item label="TG链接" prop="telegram">
          <el-input type="text" v-model="form.telegram" clearable/>
        </el-form-item>
        <el-form-item label="推特链接" prop="twitter">
          <el-input type="text" v-model="form.twitter" clearable/>
        </el-form-item>
        <el-form-item label="主演" prop="actors">
          <el-input v-model="form.actors" type="textarea" rows="2"/>
        </el-form-item>
        <el-form-item label="团队" prop="teams">
          <el-input v-model="form.teams" type="textarea" rows="2"/>
        </el-form-item>
        <el-form-item label="发行方" prop="issuer">
          <el-input v-model="form.issuer" type="textarea" rows="2"/>
        </el-form-item>
        <el-form-item label="发行日期" prop="released_at">
          <el-input v-model="form.released_at" type="textarea" rows="2"/>
        </el-form-item>
        <el-form-item label="推荐" prop="recommend">
          <el-switch v-model="form.recommend" :active-value="1" :inactive-value="0" class="drawer-switch"/>
        </el-form-item>

        <el-form-item label="上下架" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" class="drawer-switch"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog v-if="dialogFormVisible1" title="绑定短剧" :visible.sync="dialogFormVisible1" width="60%"
               :close-on-click-modal="false">
      <el-form ref="form1" :model="form1" size="mini" label-width="120px" style="width: 90%;">
        <el-form-item label="短剧" prop="selectedTags">
          <el-select
              v-model="form1.system_video_id"
              placeholder="请选择"
              filterable
              remote
              :remote-method="remoteSearch"
              :loading="loading"
              @focus="onFocus"
              style="width: 100%;"
          >
            <el-option
                v-for="item in filteredVideos"
                :key="item.id"
                :label="item.video.video_title"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="单价" prop="episode_unit_price" v-if="form1.system_video_id">
          <el-input type="text" v-model="form1.episode_unit_price" clearable/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import moment from "moment";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      form: {},
      selectedTags: [],
      btnLoading: false,
      tags: [],
      dialogFormVisible1: false,
      form1: {id: undefined, system_video_id: undefined, episode_unit_price: undefined,},
      selectedTags1: [],
      btnLoading1: false,
      videos: [],
      filteredVideos: [],
      loading: false,
      syncingMint: null
    };
  },
  created() {
    this.getList();
    this.getTagList();
  },
  methods: {
    onFocus() {
      // 首次打开显示全部
      this.filteredVideos = [...this.videos];

      // 确保 v-model 的值在数组里
      if (this.form1.system_video_id) {
        const exists = this.filteredVideos.find(
            v => v.id === this.form1.system_video_id
        );
        if (!exists) {
          const selectedItem = this.videos.find(
              v => v.id === this.form1.system_video_id
          );
          if (selectedItem) {
            this.filteredVideos.unshift(selectedItem);
          }
        }
      }
    },

    remoteSearch(query) {
      this.loading = true;
      const lowerQuery = query.toLowerCase();
      this.filteredVideos = this.videos.filter(item =>
          item.video.video_title.toLowerCase().includes(lowerQuery)
      );

      // 确保 v-model 的值在数组里
      if (this.form1.system_video_id) {
        const exists = this.filteredVideos.find(
            v => v.id === this.form1.system_video_id
        );
        if (!exists) {
          const selectedItem = this.videos.find(
              v => v.id === this.form1.system_video_id
          );
          if (selectedItem) {
            this.filteredVideos.unshift(selectedItem);
          }
        }
      }
      this.loading = false;
    },
    getTagList() {
      this.listLoading = true;
      request({
        url: "/api/admin/tag/list",
        method: "get",
        params: {
          page: 1,
          limit: 1000
        },
      }).then((response) => {
        this.tags = response.data.data.map(e => e.tag);
      });
    },
    getVideoList() {
      request({
        url: "/api/admin/video/list",
        method: "get",
        params: {
          page: 1,
          limit: 999999999
        },
      }).then((response) => {
        this.videos = response.data.list;
      });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/token/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleAdd() {
      this.form = {};
      this.selectedTags = ""
      this.dialogFormVisible = true
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object))
      this.selectedTags = this.form.tags.split(',')
      this.dialogFormVisible = true
    },
    saveData() {
      this.form.tags = this.selectedTags.join(',')
      request({
        url: '/api/admin/token/save',
        method: 'post',
        data: this.form
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        });
        this.dialogFormVisible = false;
        this.getList();
      })
    },
    handleBind(object) {
      this.getVideoList()
      this.form1.id = object.id;
      this.form1.system_video_id = object.video_relation ? object.video_relation.video_id : null;
      this.form1.episode_unit_price = object.video_relation ? (object.video_relation.video ? object.video_relation.video.episode_unit_price : 0) : null;
      this.dialogFormVisible1 = true
    },
    handleSyncWhitelist(row) {
      if (!row.mint) {
        this.$message({
          type: 'warning',
          message: '该代币没有 mint 地址，无法同步白名单'
        });
        return;
      }

      this.$confirm('确认同步该代币的白名单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.syncingMint = row.mint;
        request({
          url: '/api/admin/token/sync-whitelist',
          method: 'post',
          data: { mint: row.mint }
        })
          .then((response) => {
            this.$message({
              type: 'success',
              message: `同步成功`
            });
          })
          .catch((error) => {
            const msg = error?.message || error?.response?.data?.message || '同步失败';
            this.$message({
              type: 'error',
              message: msg
            });
          })
          .finally(() => {
            this.syncingMint = null;
          });
      }).catch(() => {});
    },
    saveData1() {
      if (!this.form1.system_video_id) {
        this.$message({
          type: 'warning',
          message: '短剧不能为空!'
        });
        return
      }
      if (!this.form1.episode_unit_price) {
        this.$message({
          type: 'warning',
          message: '单价不能为空!'
        });
        return
      }

      request({
        url: '/api/admin/token/bind-video',
        method: 'post',
        data: this.form1
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        });
        this.dialogFormVisible1 = false;
        this.getList();
      })
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

.balance {
  font-size: 18px;
  font-weight: bold;
}
</style>
